import { createIcon } from '../createIcon.tsx';

export const MountainIcon = createIcon('MountainIcon', <path d="M2 21 9 9l3 5 3-4 7 11z" />);
